export default "__VITE_ASSET__f79898a4__"